export default class ExternalIDP {

  /**
   *  "object": "ExternalIdp",
      "id": 1,
      "type": 1,
      "name": "Test Idp",
      "slug": "test_idp",
      "clientId": "test_client_id",
      "clientSecret": "test_client_secret",
      "redirectUri": "http://localhost",
      "wellKnownUrl": "http://localhost",
      "idMatchType": 1,
      "createdAt": "2021-01-01T00:00:00.000000Z",
      "updatedAt": null,
      "createdBy": 1,
      "updatedBy": null
   */
  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      type: null,
      name: '',
      slug: '',
      idMatchType: 1,
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      type: this.type,
      name: this.name,
      slug: this.slug,
      clientId: this.clientId,
      clientSecret: this.clientSecret,
      redirectUri: this.redirectUri,
      wellKnownUrl: this.wellKnownUrl,
      idMatchType: this.idMatchType,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/externalIDP/model.js